import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
  groupTagData,
} from "../../../utils/GeneralUtils";

const useDeleteTagGroup = () => {
  const [deletingGroupName, setDeletingGroupName] = useState(null);
  const queryClient = useQueryClient();

  const deleteTagGroup = useMutation({
    mutationFn: ({
      scope,
      groupName,
    }: {
      scope: any;
      groupName: any;
      onSuccess?: () => void;
    }) => {
      setDeletingGroupName(groupName);

      return TenantAPI.deleteTagGroup({
        groupName: groupName,
        scope: scope,
      }).then(() => {
        const tagData = queryClient.getQueryData<any>(["tags", scope]);
        const newTags = [...tagData.tags];

        // Delete all tags in the group from the RQ cache.
        for (let i = 0; i < newTags.length; i++) {
          if (newTags[i].TagGroup === groupName) {
            newTags.splice(i, 1);
            i--;
          }
        }

        const newTagGroups = groupTagData(newTags);

        queryClient.setQueryData(["tags", scope], {
          tags: newTags,
          tagGroups: newTagGroups,
        });
      });
    },

    onSuccess: (_, { onSuccess }) => {
      callFunctionIfExists(onSuccess);
    },
    onSettled: () => {
      setDeletingGroupName(null);
    },
  });

  return {
    deleteTagGroup: deleteTagGroup.mutate,
    deletingGroup: deleteTagGroup.isPending,
    deletingGroupName: deletingGroupName,
    deleteGroupError: deleteTagGroup.error
      ? getErrorMessage(deleteTagGroup.error)
      : null,
  };
};

export default useDeleteTagGroup;
